import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TourismSchemaMarkup from './components/TourismSchemaMarkup';
import TourismHeroSection from './components/TourismHeroSection';
import TourismPainPointsSection from './components/TourismPainPointsSection';
import TourismFeaturesSection from './components/TourismFeaturesSection';
import TourismCaseStudiesSection from './components/TourismCaseStudiesSection';
import TourismFaqSection from './components/TourismFaqSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.darksidedigital.com.au';

export default function TourismPage() {
  return (
    <div className="min-h-screen" style={{ background: '#0A0A0A' }}>
      <title>Tourism Website Design Australia | Darkside Digital</title>
      <meta
        name="description"
        content="Specialist tourism website design for Australian operators — reef trips, dive centres, ferry services, adventure charters & accommodation. Rank on Google, win direct bookings, and get cited by ChatGPT & Gemini AI. Based in Mission Beach QLD."
      />
      <meta
        name="keywords"
        content="tourism website design Australia, tourism website designer, hospitality website design, Queensland tourism website, adventure tourism website, reef tour website design"
      />
      <link rel="canonical" href={`${siteUrl}/tourism-website-design`} />
      <meta name="last-modified" content="2026-03-30" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Tourism Website Design Australia | Darkside Digital" />
      <meta
        property="og:description"
        content="Specialist tourism website design for Australian operators. Rank on Google, win direct bookings, and get cited by AI. Based in Mission Beach QLD."
      />
      <meta property="og:url" content={`${siteUrl}/tourism-website-design`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Tourism Website Design Australia | Darkside Digital" />
      <meta
        name="twitter:description"
        content="Specialist tourism website design — reef trips, ferries, charters, dive centres & accommodation. Rank on Google and get cited by AI."
      />
      <TourismSchemaMarkup />

      <Navbar />
      <main>
        <TourismHeroSection />
        <TourismPainPointsSection />
        <TourismFeaturesSection />
        <TourismCaseStudiesSection />
        <TourismFaqSection />
      </main>
      <Footer />
    </div>
  );
}
